__turbopack_context__.v({
  "nav-group-title": "NavbarColumnGroup-module__F7VNwa__nav-group-title",
});
